// extracted by mini-css-extract-plugin
export default {"breadcrumb_image_container":"zxQT","breadcrumb_link_container":"_2xBQ","breadcrumb_link":"_581I","breadcrumb_link_active":"_2ssO","breadcrumb_link_disabled":"qYmF"};